.infoPanels {
    margin-right: 15px;
    overflow-wrap: break-word;
}

.moves {
    max-height: 200px;
    overflow-y: auto;
}
